module.exports = ".AddressCompact{line-height:1.4;font-style:normal}\n"